"use strict";



const menuBtn = document.querySelector('.menu-btn');
const menu = document.querySelector('.menu-wrapper');

menuBtn.addEventListener('click', () => {
	menuBtn.classList.toggle('open');
	menu.classList.toggle('open');
});

/* CHAT GPT  pour fermer mon burger menu*/
document.addEventListener('click', (e) => {
  const link = e.target.closest && e.target.closest('a');
  if (!link) return;
  const href = link.getAttribute('href');
  if (href && href.startsWith('#')) {
    menu.classList.remove('open');
    menuBtn.classList.remove('open');
  }
});


/* GRENOUILLE */
var containerGrenouille = document.getElementById("grenouille");
var animGrenouille = bodymovin.loadAnimation({
  container: containerGrenouille,
  renderer: "svg",
  autoplay: true,
  path: "./assets/images/grenouille01.json"
});

containerGrenouille.addEventListener("mouseenter", function() {
  animGrenouille.pause();
});

containerGrenouille.addEventListener("mouseleave", function() {
  animGrenouille.play();
});


/* ARAIGNÉE */
var containerAraignee = document.getElementById("araignée");
var animAraignee = bodymovin.loadAnimation({
  container: containerAraignee,
  renderer: "svg",
  autoplay: true,
  path: "./assets/images/araigne.json"
});

containerAraignee.addEventListener("mouseenter", function() {
  animAraignee.pause();
});

containerAraignee.addEventListener("mouseleave", function() {
  animAraignee.play();
});


/* SLIME */
var containerSlime = document.getElementById("slime");
var animSlime = bodymovin.loadAnimation({
  container: containerSlime,
  renderer: "svg",
  autoplay: true,
  path: "./assets/images/slime.json"
});

containerSlime.addEventListener("mouseenter", function() {
  animSlime.pause();
});

containerSlime.addEventListener("mouseleave", function() {
  animSlime.play();
});


  /* NAVIGATION QUI DISPARAÎT AU SCROLL DOWN ET RÉAPPARAÎT  */
  
  let lastScroll = 0;
  const nav = document.querySelector('.menu02');

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > lastScroll && currentScroll > 100) {
      nav.classList.add('hidden');
    } else if (currentScroll < lastScroll) {
      nav.classList.remove('hidden');
    }

    lastScroll = currentScroll;
  });


 /*  VIDEO  */
 
/* CHARGEMENT CHATGPT */


document.addEventListener("DOMContentLoaded", () => {
  const audioEl = document.getElementById("musique");
  const toggleBtn = document.getElementById("toggleMusic");
  const icon = document.getElementById("musicIcon");

  if (toggleBtn && audioEl) {
    toggleBtn.addEventListener("click", () => {
      if (audioEl.paused) {
        audioEl.play().then(() => {
          icon.src = "assets/images/iconeMusic.svg";
          toggleBtn.classList.add("on");
          toggleBtn.classList.remove("off");
        }).catch(err => {
          console.warn("Lecture audio bloquée :", err);
        });
      } else {
        audioEl.pause();
        icon.src = "assets/images/iconeMusic.svg";
        toggleBtn.classList.add("off");
        toggleBtn.classList.remove("on");
      }
    });
  }
});
  

const overlay = document.getElementById('overlay');

document.addEventListener('mousemove', (e) => {
  const x = e.clientX;
  const y = e.clientY;
  overlay.style.background = `radial-gradient(circle 600px at ${x}px ${y}px, transparent 0%, #070427ff 100%)`;
});